import _asyncToGenerator from "D:/workspace/uat/platform-uat/Platform-foundation-pc/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
//
//
//
//
//
//
//
//

export default {
  name: 'MenuItem',
  props: {
    icon: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    ismenu: {
      type: Boolean,
      default: false
    },
    isMenuTitle: {
      type: Boolean,
      default: false
    },
    isFirst: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      menuTitleShow: false,
      titleShow: false,
      iconUrl: ''
    };
  },
  created: function created() {
    this.icon && this.getIcon(this.icon);
  },
  mounted: function mounted() {
    if (this.$refs.menu) {
      if (this.$refs.menu.offsetWidth < this.$refs.menu.scrollWidth) {
        this.menuTitleShow = true;
      }
    }
    if (this.$refs.menuTitle) {
      if (this.$refs.menuTitle.offsetWidth < this.$refs.menuTitle.scrollWidth) {
        this.titleShow = true;
      }
    }
  },
  methods: {
    getIcon: function getIcon(icon) {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.$API.getRequest({
                  url: "/platform/file/downLoadPicture/".concat(icon)
                }).then(function (res) {
                  if (res.code === '0000000000') {
                    _this.iconUrl = "data:image/svg+xml;base64,".concat(res.result);
                  }
                });
              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    }
  },
  computed: {
    menuList: function menuList() {
      return this.$store.state.system.menuList;
    }
  },
  watch: {
    menuList: function menuList() {
      if (this.$refs.menu) {
        if (this.$refs.menu.offsetWidth < this.$refs.menu.scrollWidth) {
          this.menuTitleShow = true;
        }
      }
      if (this.$refs.menuTitle) {
        if (this.$refs.menuTitle.offsetWidth < this.$refs.menuTitle.scrollWidth) {
          this.titleShow = true;
        }
      }
    }
  }
};